import script from "./MoleculeDataFilterColaborators.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeDataFilterColaborators.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeDataFilterColaborators.vue?vue&type=style&index=0&id=400b3322&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400b3322"]])

export default __exports__